import { useEffect } from 'react';

/**
 * Публикует высоту элемента в CSS-переменную на `<html>`.
 *
 * Нужна там, где закреплённый элемент занимает край экрана, а остальная страница обязана оставить
 * под него место: нижняя навигация и полоса разговора. Высота считается по факту, а не задаётся
 * константой, потому что оба элемента меняются в размерах — от длины подписей до безопасной зоны
 * конкретного телефона, — и разъехавшаяся константа означает перекрытый интерфейс.
 *
 * Элемент передаётся узлом, а не ref: узел приходит из состояния, поэтому эффект пересчитывается
 * и когда элемент появляется, и когда исчезает. С ref этого не случилось бы — его подмена не
 * перезапускает эффект, и переменная осталась бы висеть от уже размонтированного элемента.
 */
export const useHeightVar = (name: string, node: HTMLElement | null) => {
  useEffect(() => {
    const root = document.documentElement;
    if (!node) {
      root.style.removeProperty(name);
      return undefined;
    }

    const publish = () => {
      root.style.setProperty(name, `${Math.round(node.getBoundingClientRect().height)}px`);
    };

    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(node);

    return () => {
      observer.disconnect();
      root.style.removeProperty(name);
    };
  }, [name, node]);
};
